// ToDo: Perhaps we should find where the user is and center the map to there, the following are the lat, long for Aus
export const DEFAULT_MAP_GEO = { lat: 25.2744, lng: 133.7751 }
export const DEFAULT_MAP_ZOOM = 2
export const FIT_BOUNDS_PADDING = { top: 77, left: 60, bottom: 40, right: 60 }
export const USER_ZOOM = {
  min: 2,
  max: 20,
}
export const DEFAULT_MAP_MAX_ZOOM = 15
